export interface ChatOnboardingProps {
  /** Force skip — useful when parent knows user has already onboarded. */
  skip?: boolean;
}

export function ChatOnboarding(_props: ChatOnboardingProps) {
  return null;
}
